module.exports = __webpack_public_path__ + "img/eba-client-2.a3fe3edc.png";